module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_suns-aee31cf11f857990ed92c1395c8ea8b7.webp";